import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    REFRESH_PROJECT: null,
  },
  'ProjectScreen',
);
